import React, { useEffect } from 'react';
import { Toaster as ReactToaster, resolveValue, toast } from 'react-hot-toast';
import { Button } from 'components/ui/button';
import ErrorIcon from 'icons/alert';
import CloseIcon from 'icons/close';
import SuccessIcon from 'icons/right';

const Toaster = () => {
  useEffect(() => {
    toast.remove();
  }, []);

  return (
    <ReactToaster>
      {(t) => (
        <section
          className={`${
            t.type === 'success' ? 'border-[#B19A6A] bg-[#f1ebde]' : 'border-red-500 bg-red-100'
          } z-[999] flex w-max justify-between rounded-md border py-2 lg:items-center`}
        >
          <section className="flex pl-3">
            <section>
              {t.type === 'success' ? <SuccessIcon className="ml-2 h-5 w-4" /> : <ErrorIcon className="ml-2 h-5 w-4" />}
            </section>
            <section>
              <p className="mx-2 text-sm font-semibold"> {resolveValue(t.message, t)}</p>
            </section>
          </section>
          <section>
            <Button
              type="button"
              className="ml-3 size-fit lg:mt-1"
              onClick={() => {
                toast.remove();
              }}
            >
              <CloseIcon className="mr-6 h-5 w-2.5 fill-primary-dark" />
            </Button>
          </section>
        </section>
      )}
    </ReactToaster>
  );
};

export default Toaster;
